export const CHECK_AUTH = 'checkAuth'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const REGISTER = 'register'
export const RESET_PASS = 'resetPass'
export const UPDATE_PAS = 'updatePass'